import React, { useContext } from "react";

import { getDefaultBuildYourOwnShopNumber } from "@stadium/redux-utils/selectors/configSelector";
import { useConfig } from "@stadium/hooks/lib/use-config";
import useTemplateSearchBox from "@stadium/shared/src/hooks/use-template-search-box";
import { usePageNameContext } from "@stadium/shared/src/contexts/page-name-provider";

import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import SearchTemplateHits from "@components/search-template-hits";
import { RequestTemplateCta } from "@components/all-templates/categories";
import { BuildYourOwnTemplateCta } from "@components/all-templates/header";

import { MOMENTS } from "@constants/routes";

import {
  CloseButton,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";

import styles from "./main.module.scss";

const emptyObj = {};

const Search = ({ data = emptyObj, closeModal }) => {
  const { searchedTerm, renderSearchBox } = useTemplateSearchBox();
  const { onTemplateSelect } = data;
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const buildYourOwnShopNumber = useConfig(getDefaultBuildYourOwnShopNumber);

  const pageName = usePageNameContext();
  const isMomentPage = pageName === MOMENTS;

  return (
    <>
      <ModalHeader className={styles.modalHeader}>
        <article>
          <div>
            Search All {isMomentPage ? "Moments" : "Templates"}
          </div>
          <CloseButton
            onClick={() => closeModal()}
            autoFocus
          />
        </article>

        <div className={styles.shareButtonGroup}>
          {renderSearchBox({ className: styles.searchBox })}
        </div>
      </ModalHeader>

      {searchedTerm && (
        <>
          <ModalBody>
            {isMobileDevice ? (
              <BottomIconHideWrapper>
                <SearchTemplateHits onTemplateSelect={onTemplateSelect} search={searchedTerm} />
              </BottomIconHideWrapper>
            ) : (
              <SearchTemplateHits onTemplateSelect={onTemplateSelect} search={searchedTerm} />
            )}
          </ModalBody>

          <ModalFooter>
            <div className={styles.modalFooterBlocks}>
              <RequestTemplateCta isMomentPage={isMomentPage} />
            </div>
           
              <BuildYourOwnTemplateCta
                onTemplateSelect={onTemplateSelect}
                buildYourOwnShopNumber={buildYourOwnShopNumber}
              />
            
          </ModalFooter>
        </>
      )}
    </>
  );
};

export default Search;
